import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './app.jsx'
import './styles.css'

ReactDOM.createRoot(document.getElementById('root')).render(<App />)
